module.exports = __webpack_public_path__ + "static/img/pause-button.aa06afd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pause-button.png
// module id = 67f+
// module chunks = 0